// MARK://dhk8/admin-shell/pages/modules/InvoicesPage
// Módulo 7 — Facturas / CFDI: lista, factura global, link a clientes fiscales →
// dhk8-erp-invoices + dhk8-fiscal-cfdi (REST + mock).
import { Link } from 'react-router-dom'
import { FileText, Users } from 'lucide-react'
import { listInvoices } from '../../lib/clients/invoices.js'
import { useAsync, asyncState } from '../../lib/use-async.js'
import { mxn } from '../../lib/money.js'

const STATUS_BADGE: Record<string, string> = { STAMPED: 'adm-badge--ok', CANCELED: 'adm-badge--danger', PENDING: 'adm-badge--warn' }
const STATUS_LABEL: Record<string, string> = { STAMPED: 'Timbrada', CANCELED: 'Cancelada', PENDING: 'Pendiente' }

export default function InvoicesPage() {
  const list = useAsync((s) => listInvoices(s))
  return (
    <div className="adm-page">
      <div className="adm-page__head">
        <div><h1 className="adm-page__title">Facturas / CFDI</h1><p className="adm-page__sub">Comprobantes timbrados, cancelación y factura global</p></div>
        <div className="adm-page__actions">
          <Link to="/invoices/customers" className="adm-btn"><Users size={16} /> Clientes fiscales</Link>
          <button className="adm-btn adm-btn--primary" disabled title="Próximamente"><FileText size={16} /> Factura global</button>
        </div>
      </div>
      {asyncState(list.loading, list.error, list.reload)}
      {list.data && <div className="adm-card adm-card--pad0"><div className="adm-list">
        {list.data.length === 0 && <div className="adm-empty">Sin facturas</div>}
        {list.data.map((inv) => (
          <Link key={inv.id} to={`/invoices/${inv.id}`} className="adm-row">
            <div className="adm-row__main"><div className="adm-row__title">{inv.folio} · {inv.customer}</div><div className="adm-row__meta">{inv.rfc} · {inv.date} · {mxn(inv.totalCents)}</div></div>
            <div className="adm-row__tail"><span className={`adm-badge ${STATUS_BADGE[inv.status]}`}>{STATUS_LABEL[inv.status]}</span><span className="adm-row__meta">→</span></div>
          </Link>
        ))}
      </div></div>}
    </div>
  )
}
